export function rowShouldUseCursorPointer(
	rowSelectBehavior?: "none" | "select" | "multiselect",
	rowSelectTrigger?: "onClickRow" | "onClickToggle"
) {
	return (
		(rowSelectBehavior === "select" || rowSelectBehavior === "multiselect") &&
		(rowSelectTrigger === undefined || rowSelectTrigger === "onClickRow")
	);
}
